(function() {
	'use strict';

	angular.module('smb-app')
		.directive('smbDocumentIndexesEdit', DocumentIndexesEditDirective)
		.controller('smbDocumentIndexesEditController', [
			'gettextCatalog',
			'pxProgressService',
			'sbToastService',
			'smbDocumentIndexDataStore',
			'smbIndexTypesDataStore',
			'smbDocumentDataStore',
			'smbDocumentDetailsPanelDataStore',
			DocumentIndexesEditController
		]);

	var templateUrl = require('./documentIndexesEdit.template');
	/**
	 * @ngdoc directive
	 * @name smb-app.smbDocumentIndexesEdit
	 * @module smb-app
	 * @restrict E
	 * @description
	 *
	 * Document index edit component for the document viewer
	 *
	 * @usage
	 *
	 * <smb-document-indexes-edit />
	 */
	function DocumentIndexesEditDirective() {
		return {
			restrict: 'E',
			controller: 'smbDocumentIndexesEditController',
			controllerAs: 'vm',
			templateUrl: templateUrl,
			bindToController: true,
			scope: {
				documentId: '@',
				documentTypeId: '@',
				documentGroupId: '@'
			}
		};
	}

	function DocumentIndexesEditController(
		gettextCatalog,
		pxProgressService,
		sbToastService,
		smbDocumentIndexDataStore,
		smbIndexTypesDataStore,
		smbDocumentDataStore,
		smbDocumentDetailsPanelDataStore
	) {
		var vm = this;
		vm.loading = false;
		vm.indexDS = smbDocumentIndexDataStore;
		vm.indexes = [];
		vm.saveIndexes = saveIndexes;
		vm.documentDetailsDS = smbDocumentDetailsPanelDataStore;
		vm.fieldsStatus = {
			isValid: true
		};

		(function initDocumentIndexesEditController() {
			vm.loading = true;
			pxProgressService.visible = true;
			smbDocumentDataStore.loadUserPermissions(vm.documentGroupId)
				.then(function() {
					if (smbDocumentDataStore.canEditFields) {
						return vm.indexDS.getIndexes(vm.documentId, vm.documentTypeId, true);
					} else {
						// Current user can't edit fields, go back to the display page
						smbDocumentDetailsPanelDataStore.toggle(smbDocumentDetailsPanelDataStore.fieldPanel);
						return false;
					}
				})
				.then(function(data) {
					if (data !== false) {
						vm.indexes = vm.indexDS.indexTypePanelModel;
					}
				})
				.finally(function() {
					vm.loading = false;
					pxProgressService.visible = false;
				});
		}());

		function saveIndexes() {	
			if(vm.fieldsStatus.isValid) {
				pxProgressService.visible = vm.loading = true;
				smbIndexTypesDataStore.setIndexTypes(vm.indexes, vm.documentId, vm.documentTypeId)
					.then(function() {
						sbToastService.showSimple(gettextCatalog.getString('Fields updated!'));
						smbDocumentDetailsPanelDataStore.toggle(smbDocumentDetailsPanelDataStore.fieldPanel);
					})
					.catch(function(){
						sbToastService.showSimple(gettextCatalog.getString('Unable to update fields.'));
					})
					.finally(function() {
						vm.loading = false;
						pxProgressService.visible = false;
					});
			}
		}
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/components/documentIndexesEdit/documentIndexesEdit.js
// module id = 84
// module chunks = 1